import { useSelector } from "react-redux";
import { selectUserStep } from "../../store/reducers/users/users.selectors";

const TOTAL_STEPS = 4;

const ProgressBar = () => {
  const step = useSelector(selectUserStep);
  const percentage = Math.round((step / TOTAL_STEPS) * 100);

  return (
    <div className="progress mb-4">
      <div
        className="progress-bar progress-bar progress-bar-animated"
        style={{ width: `${percentage}%` }}
      >
        Paso {step} de {TOTAL_STEPS}
      </div>
    </div>
  );
};

export default ProgressBar;
